
<script>
    import {onMount} from "svelte";
    import gsap from "gsap";

    let reference;

    onMount(() => {
      const timeline = gsap.timeline({repeat: -1, yoyo: true});
      const duration = Math.random() * 2;

      timeline.to(reference, {
        opacity: 0.2,
        delay: Math.random() * 2,
        duration: Math.random() * 2 + 0.5,
      }).to(reference, {
        opacity: Math.random(),
        delay: Math.random() * 2,
        duration: Math.random() * 2 + 0.5,
      }).to(reference, {
        opacity: 0.2,
        delay: Math.random() * 2,
        duration: Math.random() * 2 + 0.5,
      }).to(reference, {
          opacity: Math.random(),
          delay: Math.random() * 2,
          duration: Math.random() * 2 + 0.5,
      });

      timeline.seek(Math.random() * duration);
      timeline.play();
    });
</script>
<defs>
    <filter id="blurFilter">
        <feGaussianBlur in="SourceGraphic" stdDeviation="2"/>
    </filter>
</defs>

<circle
        r=5
        cx={0}
        cy={0}
        class="star"
        bind:this={reference}
        transform={`scale(${Math.random() * 0.8 + 0.2})`}
></circle>

<style>
    .star {
        fill: white;
        filter: url('#blurFilter');
        opacity: 0.4;
    }
</style>